import styled from 'styled-components';

export const ImageSlider = styled.div`
  padding: 5px;
  height: 300px;
  padding: 10px;
  box-sizing: border-box;
  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const TextBlock = styled.div`
  margin-top: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 40%;
  }
`;
